import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { PermissionProducts } from "~pages/Users/enums/permissionProducts.ts";
import type { DefaultOperationSuccessResponse } from "~types/response";

export type InviteNotifyUserData = {
  userId: number;
  isPendingUser: boolean;
  selectedProduct: string;
};

const useInviteNotifyUser = () => {
  const { sport, organizationId } = useParams();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, InviteNotifyUserData>({
    mutationFn: async ({ userId, isPendingUser, selectedProduct }) => {
      const url = `${sport}/o/${organizationId}/users/${userId}/${isPendingUser ? "invite" : "notify"}`;
      return await request(url, {
        method: "POST",
        body: { isForTeamManagerProduct: selectedProduct === PermissionProducts.TeamManager },
      });
    },
  });
};

export default useInviteNotifyUser;
